import { createGlobalStyle } from 'styled-components'
import { backgroundOrange, black } from '@/theme/colors'
import { fontBody, fontDisplay, fontMono } from '@/theme/fonts'
import { leading } from '@/theme/typography'

/**
 * Resets and defaults only. Type, color and motion come from the theme tokens
 * and recipes; nothing here paints an element a component then has to undo
 * (ADR 0008). Buttons signal hover with color and a press, never a lift.
 */
export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
  }

  body {
    font-family: ${fontBody};
    color: ${black};
    background-color: ${backgroundOrange};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    font-family: ${fontMono};
  }

  /* Lato is reserved for the display roles — headings, buttons, labels (see theme/typography). */
  h1, h2, h3, h4, h5, h6 {
    font-family: ${fontDisplay};
  }

  p {
    line-height: ${leading.body};
  }

  button {
    font-family: ${fontDisplay};
    cursor: pointer;
    border: none;
    outline: none;
  }

  input, textarea {
    border: none;
    outline: none;
    font-family: inherit;
  }
`
